<template>
	<div class="increment-decrement-button" @click="elementClicked">
		<button @click.prevent="decrement" class="increment-decrement-button__btn increment-decrement-button__btn--decrement" :class="{'is-active': count !== min}" aria-label="decrement value">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
				<path d="M4.93584 13.9483L19.0642 13.9483C19.581 13.9483 20 13.5293 20 13.0125C20 12.4956 19.581 12.0767 19.0642 12.0767L4.93584 12.0767C4.41899 12.0767 4 12.4956 4 13.0125C4 13.5293 4.41899 13.9483 4.93584 13.9483Z" fill="#000000"/>
			</svg>			
		</button>
		<div class="increment-decrement-button__label" aria-live="assertive">{{ count }}</div>
		<button @click.prevent="increment" class="increment-decrement-button__btn increment-decrement-button__btn--increment" :class="{'is-active': count < max}" aria-label="increment value">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M10.8853 12.0768L10.8853 5.76933C10.8853 5.25248 11.3043 4.8335 11.8211 4.8335C12.338 4.8335 12.7569 5.25248 12.7569 5.76933L12.7569 12.0768L19.0642 12.0768C19.581 12.0768 20 12.4958 20 13.0126C20 13.5295 19.581 13.9485 19.0642 13.9485L12.7569 13.9485L12.7569 19.8977C12.7569 20.4145 12.338 20.8335 11.8211 20.8335C11.3043 20.8335 10.8853 20.4145 10.8853 19.8977V13.9485L4.93584 13.9485C4.41899 13.9485 4 13.5295 4 13.0126C4 12.4958 4.41899 12.0768 4.93584 12.0768L10.8853 12.0768Z" fill="#000000"/>
			</svg>
		</button>
	</div>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 5
		},
		default: {
			type: Number,
			default: 0
		}
	},
	data: function() {
		return {
			count: this.default
		};
	},
	watch: {
		default(current, prev) {
			this.count = current;
		}
	},
	methods: {
		elementClicked(evt) {
			this.$emit('elementClicked');
		},
		increment() {
			if(this.count < this.max) {
				this.count++;
				this.$emit('changeCount', this.count);
			}
		},
		decrement() {
			if (this.count > this.min) {
				this.count--;
				this.$emit('changeCount', this.count);
			}
		}
	}
};
</script>
